import e from"styled-components";import{theme as i}from"../../../../../theme.js";const t=e.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  padding: 0 ${i.spacing*2}px;
  .brand {
    display: flex;
    align-items: center;
    > svg {
      width: 121px;
      height: 30px;
    }
  }
  .left-section {
    display: flex;
    align-items: center;
    gap: ${i.spacing*2}px;
  }
`,o=e.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border: none;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${i.colors.shades[0]};
    }
  }
`,r=e.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${i.colors.shades[0]};
  padding: ${i.spacing*4}px;
  box-sizing: border-box;
  overflow-y: auto;
  width: 100%;
  height: 100vh;
  transition: all .2s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  &.close {
    opacity: 0;
    visibility: hidden;
    transform: translateX(-100px);
  }
  &.open {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
`,n=e.div`
  padding: ${i.spacing*4}px;
  border-radius: ${i.radius}px;
  background-color: ${i.colors.gray[100]};
  color: ${i.colors.primary[500]};
  font-size: 14px;
  font-weight: 700;
  height: 56px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  outline: none;
  border: none;
  > svg {
    width: 24px;
    height: 24px;
    transform: rotate(-180deg);
    > g, path {
      fill: ${i.colors.primary[500]};
    }
  }
`,a=e.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  overflow-y: auto;
  .list-label {
    font-size: 18px;
    font-weight: 700;
    color: ${i.colors.gray[800]};
    margin: 0;
  }
  a {
    color: inherit;
    text-decoration: unset;
  }
`,s=e.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 24px;
`,p=e.button`
  border: none;
  padding: 0;
  background-color: unset;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-self: flex-end;
  width: 40px;
  height: 40px;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${i.colors.gray[500]};
    }
  }
`,l=e.button`
  border: none;
  padding: 0;
  color: ${i.colors.primary[500]};
  width: max-content;
  display: flex;
  gap: ${i.spacing*2}px;
  align-items: center;
  background-color: unset;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${i.colors.primary[500]};
    }
  }
`,d=e.a`
  display: flex;
  gap: ${i.spacing*2}px;
  align-items: center;
  justify-content: center;
  color: ${i.colors.primary[500]} !important;
  background-color: ${i.colors.gray[100]};
  border-radius: ${i.radius}px;
  min-height: 48px;
  font-size: 14px;
  font-weight: 700;
  > svg {
    width: 24px;
    height: 24px;
    > g,
    path {
      fill: ${i.colors.primary[500]};
    }
    &:nth-child(2) {
      transform: rotate(-180deg);
    }
  }
`;export{p as CloseDrawerButton,t as Container,r as Drawer,n as DrawerButton,s as DrawerHeaderContainer,l as GoBackButton,a as ListContainer,o as MenuButton,d as SeeMoreButton};
